export class toggleHours {
  constructor(name, context) {
    this.name = name;
    this.context = context;
  }

  init() {
    /* istanbul ignore else - this is always true */
    if (this.context.querySelectorAll(this.name)) {
      const showBtn = this.context.querySelectorAll(this.name);
      showBtn.forEach((btn, i) => {
        btn.addEventListener('click', (e) => {
          const hoursWrap = this.context.querySelectorAll(
            '.location-card--content--hours'
          )[i];

          hoursWrap.classList.contains('hours-hidden')
            ? hoursWrap.classList.remove('hours-hidden')
            : hoursWrap.classList.add('hours-hidden');
        });
      });
    }
  }
}

export class locationCard extends DrupalBehavior {
  onContent(context) {
    const showHours = new toggleHours(
      '.location-card--content--hours--btn-wrap.expand button',
      context
    );
    const hideHours = new toggleHours(
      '.location-card--content--hours--btn-wrap.collapse button',
      context
    );

    showHours.init();
    hideHours.init();
  }
}

DrupalBehavior.register('rush_theme.components', 'location_card', locationCard);
